module.exports = __webpack_public_path__ + "static/media/card-logo-1.cfa86653.svg";